import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67c26f88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-header-title w-full -ml-2 -mr-2" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "mt-2 mr-2 ml-0 mb-0 font-normal" }
const _hoisted_4 = { class: "col-4 col-offset-2 flex justify-content-end align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "field-radiobutton md:mr-1"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "only-this",
  class: "ml-2"
}, "今回の予約", -1))
const _hoisted_7 = { class: "field-radiobutton md:mr-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "this_and_following",
  class: "ml-2"
}, "今回と次回以降の予約", -1))
const _hoisted_9 = { class: "col-12 flex justify-content-center mt-2" }

import { withDefaults, ref, computed } from "vue";

/**
 * PrimeVue UIコンポーネント
 * - Button: ボタンコンポーネント（保存、複製、キャンセル用）
 * - Dialog: モーダルダイアログ（定期的な予約編集用）
 * - RadioButton: ラジオボタン（更新タイプ選択用）
 */
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import RadioButton from "primevue/radiobutton";

/**
 * VueUseユーティリティライブラリ
 * - set: リアクティブな値の設定（updateTypeの更新用）
 */
import { set } from "@vueuse/core";

/**
 * 更新タイプの定数定義
 */
type UpdateType = (typeof UPDATE_TYPES)[keyof typeof UPDATE_TYPES];

/**
 * ラジオボタンの選択変更を処理する
 * @param {Event} e - 変更イベント
 */
type IHeaderEditSidebar = {
  /** 予約ID */
  bookingId: string | undefined;
  /** 予約タイプ（normal, repeat, request等） */
  bookingType: string;
  /** 繰り返しパラメータの変更フラグ */
  changeRepeatParam: boolean;
  /** 元の予約タイプ */
  originalBookingType: string;
  /** 自由予約フラグ */
  is_free_space?: boolean;
};

/**
 * コンポーネントのプロパティ定義
 * デフォルト値を設定
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    bookingId: { default: "" },
    bookingType: { default: "" },
    changeRepeatParam: { type: Boolean, default: false },
    originalBookingType: { default: "" },
    is_free_space: { type: Boolean }
  },
  emits: ["save"],
  setup(__props: any, { emit: emits }) {

const props = __props as { bookingId: string | undefined, bookingType: string, changeRepeatParam: boolean, originalBookingType: string, is_free_space?: boolean };

/**
 * Vue 3 Composition APIの基本機能
 * - withDefaults: プロパティのデフォルト値を設定
 * - defineProps: コンポーネントのプロパティを定義
 * - defineEmits: コンポーネントから親へのイベント発行を定義
 * - ref: リアクティブな参照を作成
 * - computed: 計算されたプロパティを作成
 */
const UPDATE_TYPES = {
  ONLY_THIS: "update_only_this",
  THIS_AND_FOLLOWING: "update_this_and_following",
} as const;

/**
 * 更新タイプの型定義
 */
const onChangeUpdateType = (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (target && target.value) {
    set(updateType, target.value as UpdateType);
  }
};

/** 定期的な予約編集ダイアログの表示状態 */
const visible = ref<boolean>(false);

/** 更新タイプ（今回のみ / 今回と次回以降） */
const updateType = ref<UpdateType>(UPDATE_TYPES.ONLY_THIS);

/**
 * ヘッダー編集サイドバーのプロパティ型定義
 */


/**
 * 自由予約かどうかを判定する
 * @returns {boolean} 自由予約の場合はtrue
 */
const isFreeSpace = computed(() => {
  return !!props.is_free_space;
});

/**
 * コンポーネントから親コンポーネントへのイベント発行
 */


/**
 * 保存ボタンクリック時の処理
 * @param {UpdateType} updateType - 更新タイプ
 */
const onSave = (updateType: UpdateType) => {
  emits("save", updateType);
};

/**
 * 定期的な予約編集ダイアログを開く
 */
const onOpenDialog = () => {
  console.log(props.changeRepeatParam);
  set(visible, true);
};

/**
 * 定期的な予約編集ダイアログを閉じる
 */
const onCloseDialog = () => {
  set(visible, false);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(isFreeSpace) ? "自由予約変更" : "予約変更"), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Button), {
        label: "保存",
        class: "btn-orange",
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
          props.bookingType == 'repeat' && props.originalBookingType != 'normal'
            ? onOpenDialog()
            : onSave(_unref(UPDATE_TYPES).ONLY_THIS)
        ))
      })
    ]),
    _createVNode(_unref(Dialog), {
      visible: visible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: "定期的な予約を編集する",
      draggable: false,
      style: { width: '400px' }
    }, {
      default: _withCtx(() => [
        (!__props.changeRepeatParam)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(RadioButton), {
                inputId: "only-this",
                name: "update_type",
                modelValue: updateType.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((updateType).value = $event)),
                value: _unref(UPDATE_TYPES).ONLY_THIS,
                required: true,
                onChange: _cache[2] || (_cache[2] = ($event: any) => (onChangeUpdateType($event)))
              }, null, 8, ["modelValue", "value"]),
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(RadioButton), {
            inputId: "this-and_following",
            name: "update_type",
            modelValue: updateType.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((updateType).value = $event)),
            value: _unref(UPDATE_TYPES).THIS_AND_FOLLOWING,
            required: true,
            onChange: _cache[4] || (_cache[4] = ($event: any) => (onChangeUpdateType($event)))
          }, null, 8, ["modelValue", "value"]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(Button), {
            label: "キャンセル",
            class: "p-button-light mr-5",
            onClick: onCloseDialog
          }),
          _createVNode(_unref(Button), {
            label: "保存",
            class: "text-white",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (onSave(updateType.value)))
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})